/**
 * Article comparison: same prompt (“Tell me a joke”) on GPT-4o vs. GPT-3.5-turbo.
 */
export const JOKE_GPT_4O_GENERATIONS: string[] = [
  "Why don't skeletons fight each other? They don't have the guts.",
  'Why did the scarecrow win an award? Because he was outstanding in his field!',
  'Why don’t scientists trust atoms? Because they make up everything!',
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't skeletons fight each other? They don't have the guts!",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't skeletons fight each other? They don't have the guts.",
  'Why did the scarecrow win an award? Because he was outstanding in his field!',
  'Why don’t scientists trust atoms? Because they make up everything!',
  'Why don’t scientists trust atoms? Because they make up everything!',
  "Why don't scientists trust atoms? Because they make up everything!",
  "Why don't scientists trust atoms? Because they make up everything!",
  "Why don't scientists trust atoms? Because they make up everything!",
  "Why don't scientists trust atoms? Because they make up everything!",
  "Why don't scientists trust atoms? Because they make up everything!",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't scientists trust atoms? Because they make up everything!",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't scientists trust atoms? Because they make up everything!",
  "Why don't scientists trust atoms? Because they make up everything!",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't scientists trust atoms? Because they make up everything!",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't scientists trust atoms? Because they make up everything!",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't scientists trust atoms? Because they make up everything!",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't scientists trust atoms? Because they make up everything!",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't skeletons fight each other? They don't have the guts.",
  "Why don't scientists trust atoms? Because they make up everything!",
  "Why don't scientists trust atoms? Because they make up everything!",
  "Why don't skeletons fight each other? They don't have the guts.",
];

export const JOKE_GPT_35_TURBO_GENERATIONS: string[] = [
  "Why don't scientists trust atoms? Because they make up everything!",
  "Sure, why couldn't the leopard play hide and seek? Because he was always spotted!",
  "Why couldn't the bicycle find its way home? It lost its bearings!",
  "Sure! Why couldn't the bicycle stand up by itself?",
  "Why don't scientists trust atoms? Because they make up everything!",
  "Why don't scientists trust atoms? Because they make up everything!",
  'Why did the scarecrow win an award? Because he was outstanding in his field!',
  "Why couldn't the bicycle find its way home? It lost its bearings!",
  "Why couldn't the bicycle stand up by itself? It was two tired!",
  'Why did the tomato turn red? Because it saw the salad dressing!',
  "Why don't scientists trust atoms? Because they make up everything!",
  'Why was the math book sad? Because it had too many problems.',
  "Why couldn't the bicycle stand up by itself? It was two tired!",
  "Why couldn't the bicycle stand up by itself? It was two tired!",
  "Why couldn't the bicycle stand up by itself? It was two tired!",
  "Sure! Why couldn't the bicycle stand up by itself? It was two tired.",
  "Why couldn't the bicycle stand up by itself? Because it was two tired!",
  "Why couldn't the bicycle find its way home? It lost its bearings!",
  "Why couldn't the leopard play hide and seek? Because he was always spotted!",
  "Why couldn't the bicycle find its way home? Because it lost its bearings!",
  "Sure! Why couldn't the bicycle stand up by itself? It was two tired!",
  "Why couldn't the bicycle find its way home? Because it lost its bearings!",
  'Why did the scarecrow win an award? Because he was outstanding in his field!',
  'Why did the scarecrow win an award? Because he was outstanding in his field!',
  'Why did the math book look sad? Because it had too many problems.',
  "Why couldn't the bicycle find its way home? Because it lost its bearings!",
  "Why couldn't the bicycle find its way home? Because it lost its bearings!",
  'Why did the scarecrow win an award? Because he was outstanding in his field!',
  "Why couldn't the bicycle stand up by itself? Because it was two tired!",
  "Why couldn't the bicycle find its way home? It lost its bearings!",
  "Why couldn't the bicycle find its way home? Because it lost its bearings!",
  'Why was the math book sad? It had too many problems.',
  "Why couldn't the bicycle stand up by itself? It was two tired!",
  'Why was the math book sad? Because it had too many problems.',
  "Why couldn't the bicycle stand up by itself? It was two tired!",
  'Why was Cinderella so bad at soccer? She kept running away from the ball!',
  'Why did the scarecrow win an award? Because he was outstanding in his field!',
  "Why couldn't the bicycle stand up by itself? It was two tired!",
  'Why did the scarecrow win an award? Because he was outstanding in his field!',
  "Why couldn't the bicycle stand up by itself? It was two-tired!",
  'Why did the scarecrow win an award? Because he was outstanding in his field!',
  "Why couldn't the bicycle stand up by itself? It was two-tired!",
  'Why did the scarecrow win an award? Because he was outstanding in his field!',
  "Why couldn't the bicycle find its way home? It lost its bearings!",
  "Why couldn't the bicycle find its way home? It lost its bearings!",
  "Why don't scientists trust atoms? Because they make up everything!",
  "Why couldn't the bicycle stand up by itself? It was two tired!",
  "Why couldn't the bicycle stand up by itself? It was two tired!",
  "Why couldn't the bicycle find its way home? It lost its bearings!",
  "Why don't scientists trust atoms? Because they make up everything!",
];
